const guiColors = {
    'motion-primary': 'hsla(260, 60%, 60%, 1)',
    'motion-primary-transparent': 'hsla(260, 60%, 60%, 0.9)',
    'motion-tertiary': 'hsla(260, 42%, 51%, 1)',

    'looks-secondary': 'hsla(260, 60%, 60%, 1)',
    'looks-transparent': 'hsla(260, 60%, 60%, 0.35)',
    'looks-light-transparent': 'hsla(260, 60%, 60%, 0.15)',
    'looks-secondary-dark': 'hsla(260, 42%, 51%, 1)',

    'mode-toggle':'#b078d6',
    'tabswitcher-tabs-equles':'#8a5fd3',
    'tabswitcher-tabs-noequles':'#e0d3f5',
    'tabswitcher-programe-down':'#e6d9ff',
    'tabswitcher-control-first':'#faf7fd',
    'tabswitcher-control-second':'#f4f0ff',
    'tabswitcher-control-third':'#eee0f8',
    'tabswitcher-serial-second':'#f0e0f8',
    'ic-main-1': '#855cd6',//当前项目主颜色
    'ic-main-light-2': '#9d81d6',//当前项目主颜色--浅色
    'ic-main-light-very-3': '#e5daf9',//当前项目主颜色--更浅色
    'ic-main-light-pluse-4': '#efecf5'//当前项目主颜色--极浅色
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
